<template>
  <v-footer>
      <div>
        <v-img id="footer-flag" src="@/assets/eu_flag.svg"/>
        «Replacement of Contentious Inputs in Organic Farming Systems» (RELACS) has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement No 773431. The information contained in this communication only reflects the author’s view.
      </div>
      <div id="footer-bottom">
        <v-row>
          <v-col cols="6">
            © {{$t('footer.institute')}}
          </v-col>
          <v-col cols="6">
            <router-link to="/info/data-protection">
              {{$t('footer.privacyPolicy')}}
            </router-link>
            <router-link to="/info/imprint">
              {{$t('footer.imprint')}}
            </router-link>
          </v-col>
        </v-row>
      </div>
  </v-footer>
</template>

<script>
export default {

}
</script>

<style lang="scss">
</style>
